import React from 'react';
// import theme from './ChangeRequestTooltip.module.scss';
import { useAsyncState } from '@/utils/hooks';
import { getChangeRequest } from '@/services/change-requests';
import { Tooltip, TooltipChildren } from '@/components/Tooltip';

interface ChangeRequestTooltipProps {
    changeRequestId: number;
    children: TooltipChildren;
}

const ChangeRequestTooltip: React.FC<ChangeRequestTooltipProps> = ({ changeRequestId, children }) => {
    const [changeRequest] = useAsyncState(() => getChangeRequest(changeRequestId), [changeRequestId], null);

    return (
        <Tooltip
            color="light"
            title={changeRequest?.subject}
            content={<div className="preserve-white-space">{changeRequest?.description}</div>}>
            {children}
        </Tooltip>
    );
};

export default ChangeRequestTooltip;
